module.exports = __webpack_public_path__ + "img/tutorial_war_06.d23a9c73.gif";